export default __webpack_public_path__ + "static/media/KLE.6fb5b29a.png";